import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [['RM', 'Roxana M.', 'Buenos Aires', 'Dejé de improvisar. Ahora tengo frases listas y sé cuándo pausar. Las discusiones bajaron muchísimo.'], ['VS', 'Valeria S.', 'La Plata', 'El semáforo de tensión me salvó. Identifico a tiempo cuándo todo se va a descontrolar y freno antes.'], ['DR', 'Daniela R.', 'Quilmes', 'Por primera vez siento que no estoy sola. Tengo un plan para cada momento difícil y eso me da paz.'], ['SG', 'Silvia G.', 'San Isidro', 'Mi papá sigue teniendo el Párkinson, pero la relación cambió. Ahora nos comunicamos mejor, sin tanto enojo.']] as const;
const extended = [['Roxana M.', 'Buenos Aires', '“Dejé de improvisar. Ahora tengo frases listas y sé cuándo pausar. Las discusiones bajaron muchísimo.”'], ['Valeria S.', 'La Plata', '“El semáforo de tensión me salvó. Identifico a tiempo cuándo todo se va a descontrolar y freno antes.”'], ['Daniela R.', 'Quilmes', '“Por primera vez siento que no estoy sola. Tengo un plan para cada momento difícil y eso me da paz.”'], ['Silvia G.', 'San Isidro', '“Mi papá sigue teniendo el Párkinson, pero la relación cambió. Ahora nos comunicamos mejor, sin tanto enojo.”'], ['Marta L.', 'Flores', '“Llegué al punto de gritar todos los días. Ahora uso el protocolo y las cosas son distintas. Menos tensión, más claridad.”']] as const;
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-170" data-mp="1zaxnz2htasvl">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-171" data-mp="2498xtd83x3dt" />)}
    </div>;
}
export function StatsAndProof() {
  const stats = [['+380', 'cuidadoras ya usando el sistema'], ['3', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['4.8/5', 'calificación']];
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-172" data-mp="2i3jfjalorxad">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-173" data-mp="2n2ct130z3oaj">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-174" data-mp="mzv83t1h6qj1">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-175" data-mp="ixqegub11twe">
                {value}
              </p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-176" data-mp="wpemomi5ny83">
                {label}
              </p>
            </div>)}
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-177" data-mp="16msujxq0jeos">
        <div className="mx-auto max-w-6xl" data-id="element-178" data-mp="16p5lh0dr0zdz">
          <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-179" data-mp="11ohkpmzpx46k">
            💬 LO QUE DICEN LAS CUIDADORAS
          </h2>
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4" data-id="element-180" data-mp="1fld7ei8w6u53">
            {testimonials.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className="flex h-full flex-col rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-181" data-mp="3hekj7hpaqtm8" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-182" data-mp="1wyw77nms5h28">
                  <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-183" data-mp="1j4vk5r56xihp">
                    {initials}
                  </div>
                  <div data-id="element-184" data-mp="196peqzk6du83">
                    <h3 className="font-bold" data-id="element-185" data-mp="199k3v4e4w37u">{name}</h3>
                    <p className="text-sm text-slate-400" data-id="element-186" data-mp="1e7ljtgg9jmf3">{place}</p>
                  </div>
                </div>
                <div className="mt-5" data-id="element-187" data-mp="10840vhpnf3dn">
                  <Stars data-id="element-188" data-mp="1095ffw5vi804" />
                </div>
                <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-189" data-mp="149fj32670mbt">
                  “{quote}”
                </p>
              </motion.article>)}
          </div>
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-190" data-mp="2yk2nd0zbm4f0">
      <div className="mx-auto max-w-5xl" data-id="element-191" data-mp="29tomhg6gs4zy">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-192" data-mp="24w4w5hwhs1rn">
          LO QUE DICEN LAS CUIDADORAS
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-193" data-mp="1zzo9ks4xxvgo">
          {extended.map(([name, place, quote]) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-194" data-mp="1uy8m6tfajcv4">
              <Stars data-id="element-195" data-mp="1qygd8flzj4p8" />
              <p className="mt-2 font-bold" data-id="element-196" data-mp="1qyzxw430s76y">
                {name}{' '}
                <span className="font-normal text-slate-400" data-id="element-197" data-mp="1m4lx1m5l97uw">· {place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-198" data-mp="1h7vk37p2ysdp">
                {quote}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}